import React from 'react';
import { Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';

const ConfirmationModal = ({
  show,
  title,
  confirmationText,
  handleConfirm,
  handleClose,
  isLoading = false,
  confirmClass,
  children,
}) => {
  const extraConfirmClass = confirmClass ? confirmClass : 'btn-primary';

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {confirmationText && <p>{confirmationText}</p>}
        {children}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className={'btn ' + extraConfirmClass} onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? <Loader type="Oval" color="#FFFFFF" height={30} width={30} /> : 'Confirm'}
        </button>
        <button type="button" className="btn btn-default" onClick={handleClose}>
          {isLoading ? <Loader type="Oval" color="#FFFFFF" height={30} width={30} /> : 'Cancel'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
